<template>
  <p class="tit"><b class="line"></b>{{title}}</p>
</template>

<script>
export default {
  name: "EditTitle",
  props: {
    title: String
  },
  data () {
    return {};
  }
};
</script>

<style lang="less">
.tit {
    display: flex;
    align-items: center;
    margin: 20px 0;
    color: #333;
    .line {
      display: inline-block;
      height: 12px;
      margin-right: 15px;
      border: 1px solid #3576e0;
      background-color: #3576e0;
      border-radius: 1px;
      line-height: 26px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/title.vue